<template lang="pug">
.card-sale-model(v-if="relCardList.length")
  .header-box
    .left 你有专享购卡优惠
    .right
      span 距结束还剩
      CountDown
  .card-box
    .card-list
      .card-item(v-for="(item) in relCardList")
        img.card-img(:src="item.icon")
        .card-info
          .name.text-ellipsis {{item.title}}
          .desc {{item.subtitle}}
        .card-action
          .price 原价 {{item.originalPrice}}元
          .buy-button(@click="buyAction(item)") {{item.buyButtonText}}
    .show-all-btn(@click='showAllHandle' v-if="!showAll && cardList.length > 3")
      span 查看更多
      img.arrow(src="https://m.hellobike.com/resource/gallery/847/q5EOg1g0_Path.png")
</template>
<script>
// import { safeGet } from '@/utils';
import Toast from '@/components/toast';
import Loading from '@/components/loading';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getSystemCode } from '@/utils/systemCode';
import { querySignedGoodsList, createOrder, callDouYinPayAndSign } from '../common/helper';
import CountDown from './count-down.vue';
import {
  CHARGE_TYPE,
  ORDER_TYPE,
} from '../common/const';

export default {
  components: {
    CountDown,
  },
  props: {
    filterGoods: {
      type: Array,
      default: () => [],
    },
    goodsTagMapping: {
      type: Object,
      default: () => ({}),
    },
    categoryIds: {
      type: Array,
      default: () => [],
    },
    adsource: {
      type: String,
      default: '',
    },
    spuId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 卡片列表
      cardList: [],
      // 是否展示全部
      showAll: false,
    };
  },
  computed: {
    // 卡片列表，页面真正展示的列表
    relCardList() {
      // 售卡模块的商品列表需要过滤掉与主商品相同的spu
      const filterList = this.cardList.filter(
        (item) => !this.filterGoods.includes(item.spuId),
      ).slice(0, 10);
      if (this.showAll) {
        return filterList;
      }
      return filterList.slice(0, 3);
    },
  },
  mounted() {
    // 完成页商品推荐模块模块曝光
    UBT.moduleExpose({
      pageId: 'platform_tt_card_finish',
      categoryId: 'platform',
      moduleId: 'platform_tt_card_finish_recommend',
      contentId: 'platform_tt_card_finish_recommend',
      exposureTimes: 1,
      businessInfo: {
        spuId: this.spuId,
        systemcode: getSystemCode(),
        adsource: this.adsource,
      },
    });
    this.getGoodsList();
  },
  methods: {
    /**
     * 展开全部
     */
    showAllHandle() {
      this.showAll = true;
    },
    /**
     * 获取商品列表
     */
    async getGoodsList() {
      const { cardList } = await querySignedGoodsList({
        categoryIds: this.categoryIds,
        categoryId: this.categoryIds[0],
        goodsHide: 1, // 查询隐藏商品
      });

      this.cardList = cardList;
    },
    /**
     * 点击购买按钮
     */
    async buyAction(item) {
      // 完成页商品推荐模块模块点击
      UBT.clickButton({
        pageId: 'platform_tt_card_finish',
        buttonName: 'platform_tt_card_finish_recommend',
        categoryId: 'platform',
        businessInfo: {
          spuId: item.spuId,
          systemcode: getSystemCode(),
          adsource: this.adsource,
        },
      });
      Loading.show();
      // 支付前先创建订单
      const { success, payOrderInfo, msg } = await createOrder({
        orderType: ORDER_TYPE.NORMAL,
        payAmount: item.salePrice,
        adsource: 'balancevenue',
        chargeType: CHARGE_TYPE.PAY_AND_SIGN,
        itemList: item.goodsList,
        hideOrder: false, // 是否隐藏订单，根据订单列表是否查询隐藏订单考虑
      });
      Loading.close();
      // 下单失败，toast提示，阻止后续流程
      if (!success) {
        Toast.show(msg);
        return;
      }
      // 调用抖音免密签约并支付
      const callRes = await callDouYinPayAndSign({
        ...payOrderInfo,
        signChannel: 'douyin', // 写死douyin
        bizScene: 1, // 等海鸥提供
        productTagForDySign: this.goodsTagMapping[item.spuId],
        signMustPay: true, // 写死 true
      });
      if (callRes.success) {
        Toast.show('购买成功，请前往我的-我的资产-骑行卡查看');
        // 免签成功逻辑处理
      }
    },
  },
};
</script>

<style lang="less">
.card-sale-model {
  margin: 0.16rem auto 0.4rem;
  width: 3.51rem;
  border-radius: 0.16rem;
  padding-bottom: 0.02rem;
  background:
    linear-gradient(
      106.2deg,
      #ff41b9 -29.76%,
      #ff3c70 20.55%,
      #ff4c31 77.01%,
      #ffba43 109.99%
    );

  .header-box {
    height: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    padding: 0 0.12rem;

    .left {
      font-size: 0.14rem;
      font-weight: 500;
    }

    .right {
      font-size: 0.12rem;
      display: flex;
      align-items: center;
    }
  }

  .card-box {
    background: #fff;
    width: 3.47rem;
    margin: 0 auto;
    border-radius: 0.14rem;
    overflow: hidden;

    .card-list {
      padding: 0 0.11rem;

      .card-item {
        padding: 0.12rem 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f0f3f5;

        &:last-child {
          border-bottom: none;
        }

        .card-img {
          display: block;
          width: 0.72rem;
          height: 0.52rem;
          object-fit: contain;
          margin-right: 0.08rem;
        }

        .card-info {
          width: 1.7rem;

          .name {
            font-size: 0.16rem;
            font-weight: 500;
          }

          .desc {
            font-size: 0.12rem;
            color: #879099;
            font-weight: 400;
          }
        }

        .card-action {
          margin-left: auto;

          .price {
            color: #879099;
            font-size: 0.12rem;
            text-decoration: line-through;
            text-align: center;
            margin-bottom: 0.04rem;
          }

          .buy-button {
            width: 0.74rem;
            height: 0.28rem;
            line-height: 0.28rem;
            border-radius: 0.28rem;
            color: #fff;
            text-align: center;
            background:
              linear-gradient(
                106.2deg,
                #ff41b9 -29.76%,
                #ff3c70 20.55%,
                #ff4c31 77.01%,
                #ffba43 109.99%
              );

            &.disabled {
              background: linear-gradient(127.25deg, #c0cedc 6.27%, #abbfd2 50.46%);
            }
          }
        }
      }
    }

    .show-all-btn {
      font-size: 0.12rem;
      color: #5a6066;
      display: flex;
      justify-content: center;
      padding-bottom: 0.16rem;
      align-items: center;

      .arrow {
        width: 0.08rem;
        height: 0.04rem;
        margin-left: 0.02rem;
      }
    }
  }
}

.text-ellipsis {
  overflow: hidden; /* 超出部分隐藏 */
  white-space: nowrap; /* 禁止换行 */
  text-overflow: ellipsis; /* 显示省略号 */
}
</style>
